import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { loadComments, removeComment, updateComment } from "./comments.thunks";

type CommentsState = { url: string; key: string; value: string };

interface IComments {
	items: CommentsState[];
	visible: boolean;
	editMode: boolean;
}

const initialState: IComments = {
	items: [],
	visible: false,
	editMode: false,
};

const commentsSlice = createSlice({
	name: "commentsSlice",
	initialState,
	reducers: {
		addComment(state, { payload }: PayloadAction<CommentsState>) {
			state.items.push(payload);
		},

		changeVisibleComments(state) {
			const revertFlag = !state.visible;
			state.visible = revertFlag;
			if (!revertFlag) {
				state.editMode = revertFlag;
				document.body.querySelector("#root")!.classList.remove("custom-cursor-comment");
			}
		},
		changeEditMode(state) {
			const revertFlag = !state.editMode;
			if (revertFlag) {
				document.body.querySelector("#root")!.classList.add("custom-cursor-comment");
			} else {
				document.body.querySelector("#root")!.classList.remove("custom-cursor-comment");
			}
			state.editMode = revertFlag;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(loadComments.fulfilled, (state, action) => {
			state.items = action.payload;
		});
		builder.addCase(removeComment.fulfilled, (state, { payload }) => {
			state.items = state.items.filter((_) => payload.key !== _.key);
		});
		builder.addCase(updateComment.fulfilled, (state, { payload }) => {
			state.items = state.items.map((_) =>
				payload.key === _.key && payload.url === _.url ? { ...payload } : { ..._ },
			);
		});
	},
});

export const { addComment, changeEditMode, changeVisibleComments } = commentsSlice.actions;
export default commentsSlice.reducer;
